import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { useSelector } from 'react-redux';
import { Badge, Icon } from '@pella/sash-framework';
import { Image } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const ProjectGalleryCard = ({ data, size = 'sm', className }) => {
	const imageArr = data?.modular_blocks?.find((block) => block.all_images)?.all_images?.image;
	const isBeforeAfter = imageArr?.length > 1 ? true : false;
	const { market } = useSelector((state) => state.locations);

	return (
		<div
			data-testid='project-gallery-card'
			className={`relative border border-gray-10 transition-shadow hover:shadow-lg ${className || ''}`}
		>
			<Link
				to={data?.url}
				className='block no-underline'
			>
				{!isBeforeAfter && data?.branch_data?.[0]?.branch_retail?.includes(market?.retail_branch_id) && isValidArray(data?.badge) && (
					<Badge
						color='primary'
						className='absolute left-2 top-2 z-3 gap-x-1 xl:left-3 xl:top-3'
						size='md'
					>
						{data.badge[0].material_symbol && (
							<Icon
								name={data.badge[0].material_symbol}
								size={18}
								className='-ml-1'
							/>
						)}
						{data.badge[0].badge}
					</Badge>
				)}

				{isValidArray(imageArr) && (
					<div
						data-testid='card-image'
						className={`flex flex-nowrap ${size === 'sm' ? 'aspect-[1.6]' : 'aspect-square'}`}
					>
						{imageArr?.map((image, index) => (
							<div
								className='relative flex-1'
								key={`image-div-${index}`}
							>
								{isBeforeAfter && (
									<Badge
										color='black'
										className='absolute left-2 top-2 z-2 xl:left-2.5 xl:top-2.5'
									>
										{index === 0 ? 'Before' : 'After'}
									</Badge>
								)}

								<Image
									data={image}
									className={`!block h-full`}
								/>
							</div>
						))}
					</div>
				)}

				<div className='flex flex-row items-center gap-x-2 p-2 md:p-3 xl:p-4'>
					{data?.top_content?.heading && <p className='text-subtitle-2 flex-1 text-pretty'>{data.top_content.heading?.length > 65 ? data.top_content.heading.substring(0, 65) + '...' : data.top_content.heading}</p>}
					<Icon name='keyboard_arrow_right' />
				</div>
			</Link>
		</div>
	);
};

ProjectGalleryCard.propTypes = {
	data: PropTypes.object.isRequired,
	size: PropTypes.string,
	className: PropTypes.string,
};

export default ProjectGalleryCard;
